import {
  deleteRating,
  updateBusinessStatus,
} from '../../services/BusinessManagement/BusinessProfileService';
import {
  showSuccess,
  showError,
  showConfirmToast,
  showLoading,
  dismissToast,
  showApprove,
  showReject,
  showDeactivate,
} from '../../components/Ui/ToastNotification';

export const useBusinessActions = (businessId, refetchData) => {
  const handleDelete = async (ratingId) => {
    await showConfirmToast({
      message: 'Are you sure you want to delete this rating?',
      confirmText: 'Delete',
      onConfirm: async () => {
        const loadingToast = showLoading('Deleting rating...');
        try {
          await deleteRating(ratingId);
          dismissToast(loadingToast);
          showSuccess('Rating deleted successfully!');
          refetchData();
        } catch (error) {
          dismissToast(loadingToast);
          showError(
            error.message || 'Failed to delete rating. Please try again.',
          );
        }
      },
      onCancel: () => {
        showError('Deletion cancelled.');
      },
    });
  };

  const handleStatusChange = async (action) => {
    const actionMap = {
      approve: {
        present: 'approving',
        past: 'approved',
        toast: showApprove,
      },
      deny: {
        present: 'rejecting',
        past: 'rejected',
        toast: showReject,
      },
      deactivate: {
        present: 'deactivating',
        past: 'deactivated',
        toast: showDeactivate,
      },
      reactivate: {
        present: 'reactivating',
        past: 'reactivated',
        toast: showSuccess,
      },
    };

    const { present, past, toast } = actionMap[action] || {
      present: action,
      past: `${action}d`,
      toast: showSuccess,
    };

    await showConfirmToast({
      message: `Are you sure you want to ${action} this business?`,
      confirmText: action.charAt(0).toUpperCase() + action.slice(1),
      onConfirm: async () => {
        const loadingToast = showLoading(
          `${present.charAt(0).toUpperCase() + present.slice(1)} business...`,
        );
        try {
          await updateBusinessStatus(businessId, action);

          // Auto-activate after approval
          if (action === 'approve') {
            await refetchData();

            await new Promise((r) => setTimeout(r, 1500));

            await updateBusinessStatus(businessId, 'reactivate');
            toast(`Business ${past} and activated successfully!`);
          } else {
            toast(`Business ${past} successfully!`);
          }
          dismissToast(loadingToast);

          refetchData();
        } catch (error) {
          dismissToast(loadingToast);
          showError(
            error.message || `Failed to ${action} business. Please try again.`,
          );
        } finally {
          dismissToast(loadingToast);
        }
      },
      onCancel: () => {
        showError(
          `${action.charAt(0).toUpperCase() + action.slice(1)} cancelled.`,
        );
      },
    });
  };

  return { handleDelete, handleStatusChange };
};
